module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "6xbwgavr",
    dataset: process.env.GATSBY_SANITY_DATASET || "production"
  }
};
